import { render, staticRenderFns } from "./ClassMenu.vue?vue&type=template&id=3628a0ee&lang=pug"
import script from "./ClassMenu.vue?vue&type=script&lang=js"
export * from "./ClassMenu.vue?vue&type=script&lang=js"
import style0 from "./ClassMenu.vue?vue&type=style&index=0&id=3628a0ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports